import React from 'react'
import Logoar from "./pics/logo.jpeg";
import Share from "../../components/share.js";
import "./jawaan.css" 
import img from "./pics/hardfe.png";
const Hardfe = () => {    
  return  (
 
    <div className="shortstory-container">
        <img src={Logoar} alt="Logoar" className="logoarr" />
      <div className="blue-bg">
     
      
        
        <header class="entry-header">
		<h4 class="entry-meta"><a href="https://nooffensebut.vercel.app/MovieReviews" target='_blank' data-wpel-link="internal">Movie and Show Reviews</a></h4>
		<h1 class="entry-title">No Hard Feelings</h1>
		<div class="entry-meta">
			<span class="byline">by <span class="author vcard"><a class="url fn n" href="https://nooffensebut.vercel.app/aboutus" target='_blank' data-wpel-link="internal">Harshala</a></span></span><span class="meta-divider"> | </span><span class="posted-on"><a href="https://nooffensebut.vercel.app/content" target='_blank' rel="bookmark" data-wpel-link="internal"><time class="entry-date published" datetime="2018-03-01T07:27:10-05:00">12.10.2023</time><time class="updated" datetime="2018-03-01T11:10:42-05:00"></time></a><span>		</span></span></div>
	</header>
       
 
  <img src={img} alt="Logoar" className="moo" />

        <div className="description1-2">
            <div className="rate">Rating: 4</div> <div className="genre">Genre: Comedy</div>
            <p>Without a doubt, I found myself drawn to "No Hard Feelings" primarily because of the magnetic presence of Jennifer Lawrence. Ever since her iconic role in "The Hunger Games," I've been an avid admirer of her exceptional acting talent. Jennifer Lawrence undoubtedly ranks among the finest female lead actresses in Hollywood.</p>
<br/>
<p>"No Hard Feelings" is a delightful and refreshingly quirky film that takes place against the stunning backdrop of Montauk, New York, with its picturesque beach setting. Jennifer Lawrence takes on the role of Maddie, a bold and fiercely independent woman in her thirties who finds herself grappling with financial troubles, particularly the looming burden of paying taxes on her house. Her life takes an unexpected turn when she is presented with a unique proposition by a wealthy couple: in exchange for a car, she is tasked with dating and, quite remarkably, sleeping with their 19-year-old son, Percy.</p>
<br/>
<p>What ensues is a rollicking and sex-centric comedy that is guaranteed to have you in fits of laughter throughout. Maddie, armed with her confidence and cunning, initially believes she can easily seduce Percy to fulfill her end of the bargain. However, Percy proves to be a challenging puzzle to crack. He's an introverted and emotionally complex young man who yearns for a genuine emotional connection rather than a casual fling.</p>
<br/>
<p>The heart of the movie lies in the hilarious and often outrageous attempts Maddie makes to win Percy over. Her unconventional seduction techniques and the comical situations they lead to are a riot to watch, making "No Hard Feelings" a laugh-out-loud experience.</p>
<br/>
<p>In addition to Jennifer Lawrence's brilliant portrayal of Maddie, credit must also be given to Andrew Barth, who brings Percy's character to life with exceptional skill. His portrayal of Percy's socially awkward yet endearing personality adds depth to the movie and enhances the overall chemistry between the two lead characters.</p>
<br/>
<p>However, what truly sets "No Hard Feelings" apart is its ability to balance humor with a heartwarming narrative. As the story unfolds, it becomes evident that the age gap between Maddie and Percy isn't a barrier but rather a bridge to an unexpected and beautiful friendship. The film reminds us that connections can form in the most unlikely of circumstances and that genuine human connections can transcend age and social norms.</p>
          <br/>


    <hr></hr>
</div>



          <Share/>
      </div>
</div> )}

export default  Hardfe;

 


